import { computed, Ref, watch } from 'vue';

import { useAlertStore } from '../alert/alert';
import { AlertMessage, AlertSeverity, AlertType, FullScreenAlertMessage, ModalAlertMessage, ToastAlertMessage } from '../alert/types';

function useErrorMsg(error: Readonly<Ref<unknown>>, alertMsg: Readonly<Ref<AlertMessage>>) {
  const alertState = useAlertStore();

  watch(
    [error, alertMsg],
    ([err, alertMsg]) => {
      if (err) {
        alertState.addAlertMessage({ ...alertMsg });
      } else if (!err && alertMsg.id) {
        alertState.removeAlertMessage(alertMsg.id);
      }
    },
    {
      immediate: true,
    }
  );
}

export function useFullScreenErrorMsg(
  error: Readonly<Ref<unknown>>,
  msg: Readonly<Ref<Pick<FullScreenAlertMessage, 'id' | 'title' | 'body' | 'btnAction' | 'btnTxt' | 'icon' | 'priority'>>>
) {
  return useErrorMsg(
    error,
    computed(() => ({
      ...msg.value,
      severity: AlertSeverity.Error,
      type: AlertType.FullScreen,
    }))
  );
}

export function useToastErrorMsg(error: Readonly<Ref<unknown>>, msg: Readonly<Ref<Pick<ToastAlertMessage, 'id' | 'title' | 'autoCloseInMs'>>>) {
  return useErrorMsg(
    error,
    computed(() => ({
      ...msg.value,
      severity: AlertSeverity.Error,
      type: AlertType.Toast,
    }))
  );
}

export function useModalErrorMsg(error: Readonly<Ref<unknown>>, msg: Readonly<Ref<Pick<ModalAlertMessage, 'id' | 'title' | 'body' | 'btnAction' | 'btnTxt'>>>) {
  return useErrorMsg(
    error,
    computed(() => ({
      ...msg.value,
      severity: AlertSeverity.Error,
      type: AlertType.Modal,
    }))
  );
}
